export const MULTIPLE_PARTS_DEFAULTS = {
  numberOfParts: '',
  unit: '',
  width: '',
  depth: '',
  height: '',
  assemblyInstructions: '',
}

export const MULTIPLE_PARTS_UNIT_OPTIONS = [
  { value: 'millimeters', label: 'Millimeters' },
  { value: 'centimeters', label: 'Centimeters' },
  { value: 'inches', label: 'Inches' },
  { value: 'meters', label: 'Meters' },
]

export const MULTIPLE_PARTS_UNIT_ABBREVIATIONS = {
  millimeters: 'mm',
  centimeters: 'cm',
  inches: 'in',
  meters: 'm',
}
